var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col gap-4" }, [
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "newsletter_title",
                  label: _vm.$t("newsletter.title"),
                  "label-for": "newsletter_title"
                }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "newsletter_title",
                    name: "newsletter_title",
                    disabled: ""
                  },
                  model: {
                    value: _vm.model.title,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "title", $$v)
                    },
                    expression: "model.title"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "legal_entity_name",
                  label: _vm.$t("legal_entities_unit"),
                  "label-for": "legal_entity_name"
                }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "legal_entity_name",
                    name: "legal_entity_name",
                    value: _vm.legalEntityName,
                    disabled: ""
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full sm:w-1/2" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "group_news_name",
                  label: _vm.$t("group_news.group"),
                  "label-for": "group_news_name"
                }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "group_news_name",
                    name: "group_news_name",
                    disabled: ""
                  },
                  model: {
                    value: _vm.model.group_news_name,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "group_news_name", $$v)
                    },
                    expression: "model.group_news_name"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col w-full sm:w-1/2" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "subgroup_news_name",
                  label: _vm.$t("subgroup_news.subgroup"),
                  "label-for": "subgroup_news_name"
                }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "subgroup_news_name",
                    name: "subgroup_news_name",
                    disabled: ""
                  },
                  model: {
                    value: _vm.model.subgroup_news_name,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "subgroup_news_name", $$v)
                    },
                    expression: "model.subgroup_news_name"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "newsletter_link",
                  label: _vm.$t("newsletter.link"),
                  "label-for": "newsletter_link"
                }
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:copy",
                        value: _vm.linkFull,
                        expression: "linkFull",
                        arg: "copy"
                      },
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:success",
                        value: function() {
                          _vm.notifySuccess(
                            _vm.$vs,
                            "Cópia realizada com sucesso."
                          )
                        },
                        expression:
                          "() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}",
                        arg: "success"
                      },
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:error",
                        value: function() {
                          _vm.notifyError(
                            _vm.$vs,
                            "Não foi possível realizar a cópia."
                          )
                        },
                        expression:
                          "() => {notifyError($vs, 'Não foi possível realizar a cópia.')}",
                        arg: "error"
                      },
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top",
                        value: {
                          content: "Copiar link completo",
                          delay: { show: 100, hide: 100 }
                        },
                        expression:
                          "{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}",
                        modifiers: { top: true }
                      }
                    ],
                    staticClass:
                      "align-left w-full flex text-break cursor-pointer gap-2 p-1"
                  },
                  [
                    _c("feather-icon", {
                      attrs: {
                        icon: "LinkIcon",
                        svgClasses:
                          "h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.linkFull) + " ")
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col flex" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: _vm.$t("newsletter.status"),
                  "label-for": "status"
                }
              },
              [
                _c(
                  "b-form-radio-group",
                  {
                    attrs: { id: "status", name: "status", disabled: "" },
                    model: {
                      value: _vm.model.status,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status"
                    }
                  },
                  [
                    _c("b-form-radio", { attrs: { value: "DR" } }, [
                      _vm._v(_vm._s(_vm.$t("newsletter.status_.DR")))
                    ]),
                    _c("b-form-radio", { attrs: { value: "RE" } }, [
                      _vm._v(_vm._s(_vm.$t("newsletter.status_.RE")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col flex" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: _vm.$t("newsletter.allows_comment"),
                  "label-for": "allows_comment"
                }
              },
              [
                _c("b-form-checkbox", {
                  staticClass: "mr-n2",
                  attrs: {
                    id: "allows_comment",
                    name: "allows_comment",
                    switch: "",
                    disabled: ""
                  },
                  model: {
                    value: _vm.model.allows_comment,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "allows_comment", $$v)
                    },
                    expression: "model.allows_comment"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col flex" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: _vm.$t("newsletter.allows_enjoy"),
                  "label-for": "allows_enjoy"
                }
              },
              [
                _c("b-form-checkbox", {
                  staticClass: "mr-n2",
                  attrs: {
                    id: "allows_enjoy",
                    name: "allows_enjoy",
                    switch: "",
                    disabled: ""
                  },
                  model: {
                    value: _vm.model.allows_enjoy,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "allows_enjoy", $$v)
                    },
                    expression: "model.allows_enjoy"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col flex" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: _vm.$t("newsletter.allows_signature"),
                  "label-for": "allows_signature"
                }
              },
              [
                _c("b-form-checkbox", {
                  staticClass: "mr-n2",
                  attrs: {
                    id: "allows_signature",
                    name: "allows_signature",
                    switch: "",
                    disabled: ""
                  },
                  model: {
                    value: _vm.model.allows_signature,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "allows_signature", $$v)
                    },
                    expression: "model.allows_signature"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col flex w-full" },
          [
            _c(
              "b-form-group",
              {
                staticClass: "w-full",
                attrs: {
                  label: _vm.$t("newsletter.content"),
                  "label-for": "content"
                }
              },
              [
                _c("vs-divider"),
                _c("complex-editor-view", {
                  attrs: { editor_data: _vm.model.content },
                  on: {
                    "update:editor_data": function($event) {
                      return _vm.$set(_vm.model, "content", $event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c("div", { staticClass: "vx-col w-full" }, [
          _c("div", { staticClass: "w-full flex items-center gap-3" }, [
            _c(
              "div",
              {
                staticClass: "flex items-center px-1 py-1.5 rounded",
                staticStyle: {
                  "background-color": "rgba(var(--vs-primary), 0.1)"
                }
              },
              [
                _c("feather-icon", {
                  staticClass: "h-4 w-4 text-primary mr-1",
                  attrs: { icon: "ThumbsUpIcon" }
                }),
                _c("span", { staticClass: "text-primary" }, [
                  _vm._v(_vm._s(_vm.countLike))
                ]),
                _c("span", { staticClass: "text-primary ml-1 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.like")))
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "flex items-center px-1 py-1.5 rounded",
                staticStyle: {
                  "background-color": "rgba(var(--vs-primary), 0.1)"
                }
              },
              [
                _c("feather-icon", {
                  staticClass: "h-4 w-4 text-primary mr-1",
                  attrs: { icon: "EyeIcon" }
                }),
                _c("span", { staticClass: "text-primary" }, [
                  _vm._v(_vm._s(_vm.countView))
                ]),
                _c("span", { staticClass: "text-primary ml-1 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.view")))
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "flex items-center px-1 py-1.5 rounded",
                staticStyle: {
                  "background-color": "rgba(var(--vs-primary), 0.1)"
                }
              },
              [
                _c("feather-icon", {
                  staticClass: "h-4 w-4 text-primary mr-1",
                  attrs: { icon: "MessageCircleIcon" }
                }),
                _c("span", { staticClass: "text-primary" }, [
                  _vm._v(_vm._s(_vm.countComments))
                ]),
                _c("span", { staticClass: "text-primary ml-1 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.comment_total")))
                ])
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }